export const mboxes = {
  bannerMbox: 'for-home:GraphicBanner',
  quickLinksMbox: 'for-home:QuickLinks',
  whyOriginMbox: 'for-home:CardTopLight',
  topCardsMbox: 'for-home:CardTop',
  disclaimerMbox: 'for-home:disclaimer',
  customerAbTestMbox: 'OE-411-mbox',
  prospectAbTestMbox: 'OE-414-mbox',
};
